import { render, staticRenderFns } from "./DispatchModelInfo.vue?vue&type=template&id=276fc299&scoped=true&"
import script from "./DispatchModelInfo.vue?vue&type=script&lang=js&"
export * from "./DispatchModelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276fc299",
  null
  
)

export default component.exports